/** @module Validators */

/**
 * @type {String}
 * @private
 * @const
 */
export var ERROR = 'required';
/**
 * Creates validator for required fields
 *
 * @function isRequired
 * @return {validator} isRequired validator
 */

export default function isRequired() {
  return function (value) {
    var isNull = value === null;
    var isUndefined = value === undefined;
    var isEmptyString = value === '';
    var isWhiteSpace = String(value).trim().length === 0;
    var isFalse = value === false;

    if (isNull || isUndefined || isEmptyString || isWhiteSpace || isFalse) {
      return ERROR;
    }

    return null;
  };
}